export const sessionStorageKeys = {
  TOKEN: 'Atzmai-registration-token',
  REG_TYPE: 'Atzmai-registration-regType',
  LOCALE: 'Atzmai-registration-locale',
};
